import { render, staticRenderFns } from "./ProjectResultsView.vue?vue&type=template&id=c7fd7354&scoped=true&"
import script from "./ProjectResultsView.vue?vue&type=script&lang=js&"
export * from "./ProjectResultsView.vue?vue&type=script&lang=js&"
import style0 from "./ProjectResultsView.vue?vue&type=style&index=0&id=c7fd7354&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7fd7354",
  null
  
)

export default component.exports